import React from 'react';

export const FloorPlanSaveModal = ({
  isOpen,
  projectName,
  setProjectName,
  userEmail,
  setUserEmail,
  userName,
  setUserName,
  onClose,
  onSave,
  saving,
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" data-testid="floorplan-editor-save-modal-overlay">
      <div className="bg-white rounded-2xl p-6 w-full max-w-md mx-4" data-testid="floorplan-editor-save-modal">
        <h2 className="text-xl font-bold text-gray-900 mb-4" data-testid="floorplan-editor-save-modal-title">Salvar Projeto</h2>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Nome do Projeto *</label>
            <input
              type="text"
              value={projectName}
              onChange={(event) => setProjectName(event.target.value)}
              className="w-full p-3 border rounded-lg"
              placeholder="Ex: Minha Casa dos Sonhos"
              data-testid="floorplan-editor-project-name-input"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Seu Email *</label>
            <input
              type="email"
              value={userEmail}
              onChange={(event) => setUserEmail(event.target.value)}
              className="w-full p-3 border rounded-lg"
              placeholder="seu@email.com"
              data-testid="floorplan-editor-user-email-input"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Seu Nome</label>
            <input
              type="text"
              value={userName}
              onChange={(event) => setUserName(event.target.value)}
              className="w-full p-3 border rounded-lg"
              placeholder="Seu nome completo"
              data-testid="floorplan-editor-user-name-input"
            />
          </div>
        </div>
        <div className="flex gap-3 mt-6">
          <button onClick={onClose} className="flex-1 px-4 py-3 border rounded-lg hover:bg-gray-50" data-testid="floorplan-editor-save-cancel-button">
            Cancelar
          </button>
          <button
            onClick={onSave}
            disabled={saving}
            className="flex-1 px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400"
            data-testid="floorplan-editor-save-submit-button"
          >
            {saving ? 'Salvando...' : 'Salvar'}
          </button>
        </div>
      </div>
    </div>
  );
};
